import { useAuth } from "@/_core/hooks/useAuth";
import HomeDashboard from "./HomeDashboard";
import Landing from "./Landing";

export default function Home() {
  const { loading, user } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "var(--brand-bone)" }}
      >
        <div
          className="h-8 w-8 rounded-full border-2 animate-spin"
          style={{
            borderColor: "var(--brand-mist)",
            borderTopColor: "var(--brand-teal)",
          }}
        />
      </div>
    );
  }

  return user ? <HomeDashboard /> : <Landing />;
}
